import { render, staticRenderFns } from "./addEmProfessor.vue?vue&type=template&id=2d8c7028&scoped=true&"
import script from "./addEmProfessor.vue?vue&type=script&lang=js&"
export * from "./addEmProfessor.vue?vue&type=script&lang=js&"
import style0 from "./addEmProfessor.vue?vue&type=style&index=0&id=2d8c7028&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8c7028",
  null
  
)

export default component.exports